/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, func,
} from 'prop-types';
import {  useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { getFeatureFlag } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import LinkOrATag from '../../GraphqlCommonComponents/LinkOrATag/LinkOrATag';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        width: '100%',
        flexFlow: 'row wrap',
        justifyContent: 'left',
    },
    link: {
        border: '1px solid #cbcbcb',
        textDecoration: 'none',
        padding: '14px 20px',
        borderRadius: '5px',
        fontWeight: '600',
        display: 'flex',
        transition: 'all .3s',
        alignItems: 'center',
        fontSize: '14px',
        width: '260px',
        fontFamily: theme.typography.fontFamily,
        color: 'inherit',
        margin: '20px 20px 0',
    },
    icon: {
        margin: '0 20px 0 0',
        width: '100%',
        maxWidth: '42px',
    },
    menuLink: {
        color: 'inherit',
        padding: '5px 10px',
        flexShrink: '0',
        fontSize: 14,
        '-ms-flex-negative': '0',
        // important is added to overwrite parent property
        textDecoration: 'underline !important',
    },
    imageContainer: {
        display: 'flex',
    },
    title: {
        display: 'flex',
    },
    footerV3Container: {
        marginBottom: '40px',
        '& $link': {
            border: 'none',
            textDecoration: 'none',
            padding: '0px',
            borderRadius: '0',
            fontWeight: '700',
            alignItems: 'center',
            fontSize: '16px',
            width: '100%',
            justifyContent: 'center',
            margin: '20px 0px 0px 0px',
            height: '91px',
            boxShadow: '2px 2px 4px rgba(47, 47, 47, 0.15)',
            background: theme.palette.common.white || '#fff',

        },
        '& $icon': {
            maxHeight: '42px',
        },
        '& $imageContainer': {
            width: '58px',
            height: '58px',
            background: theme.palette.footerLinkImgBg || '#E8F1ED',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '0px 18px',
            '& img': {
                margin: '0 auto',
                maxHeight: '24px',
            },
        },
        '& $title': {
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            maxWidth: '170px',
            marginRight: '10px',
        },
        [theme.breakpoints.down(1366)]: {
            '& $imageContainer': {
                margin: '0px 13px 0px 10px',
            },
        },
        [theme.breakpoints.down(1024)]: {
            marginBottom: '0px',
        },
        [theme.breakpoints.down(767)]: {
            padding: '0px 12px',

        },
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
    },
}));

const FooterCard = ({ link }) => {
    const classes = useStyles();
    const footerV3Enabled = useSelector(getFeatureFlag('is-footer-v3-enabled'));
    const isButton = link.type === 'Button';
    const isExternalLink = link.url?.href?.includes('/blog') || link.url?.href?.includes('www') || link.url?.href?.indexOf('http://') === 0 || link.url?.href?.indexOf('https://') === 0 || link.url?.href?.includes(('/articles')) || link.url?.href?.includes(('/local'));
    return (
        <div className={`${classes.container} ${footerV3Enabled ? classes.footerV3Container : ''}`} data-testid="footer-link">
            <LinkOrATag
                key={link.title}
                className={isButton ? classes.link : classes.menuLink}
                href={link.url?.href}
                isTrackEventEnabled
                trackingEventCategory={link?.tracking_event_category || ''}
                trackingEventAction={link?.tracking_event_action || ''}
                trackingEventLabel={link?.tracking_event_label || ''}
                openInNewTab={isExternalLink}
                title={link.title}
            >
                { isButton
                    ? (
                        <>
                            {link.icon?.url
                                ? <span className={classes.imageContainer}><img className={classes.icon} src={link.icon.url} alt="img" height="24px" width="42px" /></span>
                                : null}
                            <span className={classes.titleContainer}><span className={classes.title}>{link.title} </span>{footerV3Enabled && <ChevronRightIcon className={classes.chevron} />}</span>
                        </>
                    ) :  link.title }
            </LinkOrATag>

        </div>
    );
};

FooterCard.propTypes = {
    link: shape({
        type: string.isRequired,
        title: string.isRequired,
        url: shape({
            href: string.isRequired,
        }),
        icon: shape({
            url: string.isRequired,
        }),
    }).isRequired,
};

export default FooterCard;
